export default __webpack_public_path__ + "static/media/medjedjed.aed53823.jpeg";